import { render, staticRenderFns } from "./offenderDetails.vue?vue&type=template&id=3c3b50a5&scoped=true"
import script from "./offenderDetails.vue?vue&type=script&lang=js"
export * from "./offenderDetails.vue?vue&type=script&lang=js"
import style0 from "./offenderDetails.vue?vue&type=style&index=0&id=3c3b50a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3b50a5",
  null
  
)

export default component.exports